"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendScreening = exports.sendScreenout = exports.getActiveRevisionId = exports.getSurveyRequest = exports.storePageSwitch = exports.sendAnswerBulkRequest = exports.sendAnswerRequest = exports.finishSurveyRequest = void 0;
const finishSurveyRequest = (slug, answers) => {
    return {
        type: 'REQUEST_TO_API',
        steps: ['SURVEY_FINISH_PENDING', 'SURVEY_FINISH_SUCCESS', 'SURVEY_FINISH_FAILURE'],
        params: {
            slug,
            data: answers
        },
        method: 'finishSurvey'
    };
};
exports.finishSurveyRequest = finishSurveyRequest;
const sendAnswerRequest = (slug, data) => {
    return {
        type: 'REQUEST_TO_API',
        steps: [
            'SURVEY_SEND_ANSWER_PENDING',
            'SURVEY_SEND_ANSWER_SUCCESS',
            'SURVEY_SEND_ANSWER_FAILURE'
        ],
        params: {
            slug,
            data
        },
        method: 'sendAnswer'
    };
};
exports.sendAnswerRequest = sendAnswerRequest;
const sendAnswerBulkRequest = (slug, data) => {
    return {
        type: 'REQUEST_TO_API',
        steps: [
            'SURVEY_SEND_ANSWER_BULK_PENDING',
            'SURVEY_SEND_ANSWER_BULK_SUCCESS',
            'SURVEY_SEND_ANSWER_BULK_FAILURE'
        ],
        params: {
            slug,
            data
        },
        method: 'sendAnswerBulk'
    };
};
exports.sendAnswerBulkRequest = sendAnswerBulkRequest;
const storePageSwitch = (slug, pageFrom, pageTo) => {
    return {
        type: 'REQUEST_TO_API',
        steps: [
            'SURVEY_PAGE_SWITCH_PENDING',
            'SURVEY_PAGE_SWITCH_SUCCESS',
            'SURVEY_PAGE_SWITCH_FAILURE'
        ],
        params: {
            slug,
            data: {
                pageFrom,
                pageTo
            }
        },
        method: 'pageSwitch'
    };
};
exports.storePageSwitch = storePageSwitch;
const getSurveyRequest = (slug, queryString) => {
    return {
        type: 'REQUEST_TO_API',
        steps: ['SURVEY_GET_PENDING', 'SURVEY_GET_SUCCESS', 'SURVEY_GET_FAILURE'],
        params: {
            slug,
            queryString
        },
        method: 'getSurvey'
    };
};
exports.getSurveyRequest = getSurveyRequest;
const getActiveRevisionId = (slug) => {
    return {
        type: 'REQUEST_TO_API',
        steps: ['REVISION_ID_GET_PENDING', 'REVISION_ID_GET_SUCCESS', 'REVISION_ID_GET_FAILURE'],
        params: {
            slug
        },
        method: 'getActiveRevisionId'
    };
};
exports.getActiveRevisionId = getActiveRevisionId;
const sendScreenout = ({ slug, pageFrom, queryString, optionIds }) => {
    return {
        type: 'REQUEST_TO_API',
        steps: ['SURVEY_SCREENOUT_PENDING', 'SURVEY_SCREENOUT_SUCCESS', 'SURVEY_SCREENOUT_FAILURE'],
        params: {
            slug,
            queryString,
            data: {
                pageFrom,
                optionIds
            }
        },
        method: 'screenout'
    };
};
exports.sendScreenout = sendScreenout;
const sendScreening = (params) => {
    const { slug, questionId, options, queryString, quotaIds } = params;
    return {
        type: 'REQUEST_TO_API',
        steps: ['SURVEY_SCREENING_PENDING', 'SURVEY_SCREENING_SUCCESS', 'SURVEY_SCREENING_FAILURE'],
        params: {
            slug,
            queryString,
            data: {
                questionId,
                options,
                quotaIds
            }
        },
        method: 'screening'
    };
};
exports.sendScreening = sendScreening;
